import { getState, dispatch } from 'pluginServices/store';
import { setSelectedWorkspaceToStore } from 'Workspace/Admin/store/actions';
import { selectWorkspacesList } from 'Workspace/Admin/store/selectors';
import { load, save, remove } from '../../data/browserStorage';
import { LOCAL_STORAGE } from '../../data/browserStorage/constants';

const STORAGE_KEY = 'selectedWorkspace';

class WorkspaceService {
  constructor() {
    this.selectedWorkspace = null;
  }

  setSelectedWorkspace = (workspace) => {
    save(STORAGE_KEY, JSON.stringify(workspace), LOCAL_STORAGE);
    this.selectedWorkspace = workspace;
    dispatch(setSelectedWorkspaceToStore(workspace));
  }

  clearSelectedWorkspace = () => {
    remove(STORAGE_KEY, LOCAL_STORAGE);
    this.selectedWorkspace = null;
    dispatch(setSelectedWorkspaceToStore({}));
  }

  updateWorkspace = (workspaceId) => {
    if (this.selectedWorkspace?.id === workspaceId) return;

    const workspaceList = selectWorkspacesList(getState()) || [];
    const selectedWorkspace = workspaceList.find((workspace) => workspace.id === workspaceId);
    if (selectedWorkspace) {
      this.setSelectedWorkspace(selectedWorkspace);
      dispatch(setSelectedWorkspaceToStore(selectedWorkspace));
    }
  }

  getSelectedWorkspaceId = () => {
    const selectedWorkspace = load(STORAGE_KEY, LOCAL_STORAGE);

    this.selectedWorkspace = (selectedWorkspace && JSON.parse(selectedWorkspace)) || {};
    return this.selectedWorkspace.id;
  }

  getSelectedWorkspace = () => {
    const selectedWorkspace = load(STORAGE_KEY, LOCAL_STORAGE);

    this.selectedWorkspace = (selectedWorkspace && JSON.parse(selectedWorkspace)) || {};
    return this.selectedWorkspace;
  }
}

const workspaceService = new WorkspaceService();

export default workspaceService;
